<template>
  <div class="container">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  created() {
    document.title = "EV Charger Controller"
  }
}
</script>

<style>

</style>
